addEventListener("DOMContentLoaded", (event) => {

    let anchors           = document.querySelectorAll('[data-dynamic-title]');

    if ( anchors ) {
        let list    = document.querySelector('.landing__dynamic-nav__list');

        anchors.forEach( (anchor) => {
            let item    = document.createElement('a');
            item.setAttribute('href', '#shopify-section-' + anchor.getAttribute('data-section-id'));
            item.innerHTML  = anchor.innerHTML; 
            list.appendChild(item);
        });

    } else {
        document.querySelector('.landing__dynamic-nav').style.display = 'none';
    }

});

